import connector from "./connector";
import { uNumber } from "@/lib.js";

export async function CardSave(card) {
  try {
    const data = { ...card };

    // данные о файла не передаем, они самостоятельно сохранились
    delete data.pilotProjectFiles;
    delete data.infoSourceFiles;

    if (data.uNumber === undefined || data.uNumber === "") {
      data.uNumber = uNumber();
    }

    const response = await connector.post("/api/card", {
      params: data,
      method: card.id === undefined || card.id === -1 ? "new" : "edit",
    });

    return {
      data: response.data || {},
      connector_state: {
        status: response.status,
        statusText: response.statusText,
      },
    };
  } catch (error) {
    return connector.catchReturn(error, {});
  }
}

export async function CardList(params) {
  try {
    const response = await connector.get("/api/list", {
      params: { params, timestamp: `${new Date().getTime()}` },
    });

    return {
      data: response.data.items || [],
      connector_state: {
        status: response.status,
        statusText: response.statusText,
      },
    };
  } catch (error) {
    return connector.catchReturn(error, []);
  }
}

export async function CardGet(id) {
  try {
    const response = await connector.get("/api/card", {
      params: { id, timestamp: `${new Date().getTime()}` },
    });

    return {
      data: response.data || {},
      connector_state: {
        status: response.status,
        statusText: response.statusText,
      },
    };
  } catch (error) {
    return connector.catchReturn(error, {});
  }
}
